"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProviders = void 0;
var React = require("react");
var l10n_provider_1 = require("bernie-l10n/dist/components/l10n-provider");
var viewport_context_1 = require("@shared-ui/viewport-context");
var brand_context_1 = require("@shared-ui/brand-context");
var logger_1 = require("../logger");
var getProviders = function (options) {
    var deviceInformation = options.deviceInformation, localization = options.localization, loggerFactory = options.loggerFactory, brandData = options.brandData;
    var Providers = function (props) { return (React.createElement(l10n_provider_1.LocalizationContext.Provider, { value: localization },
        React.createElement(logger_1.LoggerProvider, { factory: loggerFactory },
            React.createElement(viewport_context_1.ViewportProvider, { deviceInformation: deviceInformation },
                React.createElement(brand_context_1.BrandProvider, { config: brandData }, props.children || null))))); };
    return Providers;
};
exports.getProviders = getProviders;
//# sourceMappingURL=get-providers.js.map